import { KeyCode } from "dots-ui/models/KeyCode";
import { KeyboardEvent, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AvisContext } from "../../context/AvisContext";
import { AvisLogo } from "./AvisLogo";

export function AvisLogoInteractive() {
  const navigate = useNavigate();
  const { portalKind } = useContext(AvisContext);

  const handleClick = () => navigate(`/${portalKind.portalType}`);

  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.code === KeyCode.Enter) {
      handleClick();
    }
  };

  return (
    <div className="avis-logo" tabIndex={0} onKeyDown={onKeyDown}>
      <AvisLogo handleClick={handleClick} />
    </div>
  );
}
